export = {
  techKind: {
    aces: "Cú giao bóng ăn điểm trực tiếp",
    double_faults: "Lỗi kép",
    first_serve: "Tổng số lần giao bóng lần đầu",
    first_serve_rate: "Tỷ lệ giao bóng lần đầu",
    second_serve: "Tổng số lần giao bóng lần hai",
    second_serve_rate: "Tỷ lệ giao bóng lần hai",
    break_points: "Tổng số điểm break",
    break_points_percent: "Tỷ lệ điểm break %",
    total_points: "Tổng số điểm",
    first_serve_points: "Điểm giao bóng lần đầu",
    first_serve_points_rate: "Tỉ lệ điểm giao bóng lần đầu",
    second_serve_points: "Điểm giao bóng lần 2",
    second_serve_points_rate: "Tỉ lệ điểm giao bóng lần 2",
  },
  percentKeys: [
    "first_serve_rate",
    "second_serve_rate",
    "break_points_percent",
    "first_serve_points_rate",
    "second_serve_points_rate",
  ],
  showPreKeys: [
    "first_serve",
    "second_serve",
    "break_points",
    "first_serve_points",
    "second_serve_points",
  ],
  groupType: {
    0: "Hard",
    1: "Hard",
    2: "Grass",
    3: "Clay",
    4: "Clay",
    5: "Hardcourt outdoor",
    6: "Carpet indoor",
    7: "Synthetic indoor",
    8: "Synthetic outdoor",
    9: "Hardcourt indoor",
    10: "Clay",
  },
};
